import React from "react";
import moment from "moment-timezone";

import {
  Label,
  Wrapper,
  InputsWrapper,
  StyledRotaCalendar,
  StyledTimeDateInput,
  ErrorMessage
} from "./styles";

interface DateTimePickerProps {
  label: string;
  dateTime?: moment.Moment | null;
  setDateTime: (dateTime: moment.Moment) => void;
  isError?: boolean;
  errorMessage?: string;
  selectedDate?: Date;
  maxDate?: Date;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  label,
  dateTime,
  setDateTime,
  isError,
  errorMessage,
  maxDate
}) => {
  const handleDateChange = (date: Date) => {
    const newDate = moment(date).startOf("day");

    if (dateTime) {
      newDate.hours(dateTime.hours()).minutes(dateTime.minutes());
    }

    setDateTime(newDate);
  };

  const handleTimeChange = (value: string) => {
    const [hoursStr, minutesStr] = value.split(":");
    let hours = Number(hoursStr);
    const minutes = Number(minutesStr);

    // If hours is 24 or greater, set the second digit to 0
    if (hours >= 24) {
      const hoursStr = hours.toString();
      hours = parseInt(hoursStr[0] + "0");
    }

    if (dateTime) {
      const newDateTime = dateTime
        .clone()
        .hours(hours)
        .minutes(minutes)
        .seconds(0)
        .milliseconds(0);
      setDateTime(newDateTime);
    } else {
      setDateTime(
        moment()
          .hours(hours)
          .minutes(minutes)
          .seconds(0)
          .milliseconds(0)
      );
    }
  };

  return (
    <Wrapper>
      <Label>{label}</Label>
      <InputsWrapper>
        <StyledRotaCalendar
          selectedDate={dateTime ? dateTime.toDate() : new Date()}
          onChange={({ date }: { date?: Date }) =>
            date && handleDateChange(date)
          }
          maxDate={maxDate}
        />
        {/* @ts-expect-error TS-2769 */}
        <StyledTimeDateInput
          isSmall
          type="time"
          onChange={handleTimeChange}
          value={dateTime ? dateTime.format("HH:mm") : "00:00"}
        />
      </InputsWrapper>
      {isError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Wrapper>
  );
};

export default DateTimePicker;
